import moment from "moment";

const DateHelper: any = {
  convertToAS400Date: function (date: string) {
    let momentDate;
    if (moment.isMoment(date)) {
      momentDate = date;
    } else {
      momentDate = moment(date, "MM-DD-YYYY");
    }
    let century = Number.parseInt((momentDate.year() / 100).toString()) - 19;
    let formattedDate = momentDate.format("YYMMDD");
    return Number("" + century + formattedDate);
  },

  convertDateTimeFromDB: function (
    date: string,
    time: string,
    formattedDate: string = "MM/DD/YYYY hh:mm A"
  ) {
    if(date){
      return  moment(`${date} ${time}`, "DD-MM-YYYY hh:mm:ss").format(formattedDate);
    } else {
      return "";
    }
   
  },

  convertFromAS400Time: function (time?: string) {
    if (time && time !== "") {
      if (time.length === 1) time = "" + 0 + time;
      if (time.length === 2) time = "" + 0 + time;
      if (time.length === 3) time = "" + 0 + time;
      if (time.length <= 4) {
        return time.substring(0, 2) + ":" + time.substring(2);
      } else {
        if (time.length === 5) time = "" + 0 + time;
        return (
          time.substring(0, 2) +
          ":" +
          time.substring(2, 4) +
          ":" +
          time.substring(4, 6)
        );
      }
    } else {
      return "00:00";
    }
  },
  convertFromAS400Date: function (date?: string, doFormat: boolean = true) {
    if (date && date !== "") {
      if (/^[\d.]+$/.test(date)) {
        let century = Number.parseInt(date.charAt(0)) + 19;
        let isoDate = "" + century + date.substring(1, 7);
        if (doFormat) {
          return moment(isoDate, "YYYYMMDD").format("DD/MM/YYYY");
        } else {
          return moment(isoDate, "YYYYMMDD");
        }
      } else if (new Date(date).toString() === "Invalid Date") {
        return date;
      } else {
        return moment(new Date(date)).format("YYYY-MM-DD");
      }
    } else {
      return "0";
    }
  },
  
  // To convert start date from filter date dropdown with specific selection.
  startDateSelector: (value: string) => {
    const dateMap: Record<string, () => string | undefined> = {
      TOD: () => moment().format("YYYY-MM-DD"),
      YST: () => moment().subtract(1, "days").format("YYYY-MM-DD"),
      DBY: () => moment().subtract(2, "days").format("YYYY-MM-DD"),
      MTD: () => moment().startOf("month").format("YYYY-MM-DD"),
      PMO: () => moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
      "26MO": () => moment().subtract(26, "months").format("YYYY-MM-DD"),
      "9MO": () => undefined,
    };
    
    return dateMap[value]?.();
  },

  // To convert end date from overages filter date dropdown with specific selection.
  endDateSelector: (value: string ) => {
    const dateMap: Record<string, () => string> = {
      TOD: () => moment().format("YYYY-MM-DD"),
      YST: () => moment().subtract(1, "days").format("YYYY-MM-DD"),
      DBY: () => moment().subtract(2, "days").format("YYYY-MM-DD"),
      MTD: () => moment().format("YYYY-MM-DD"),
      PMO: () => moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
      "9MO": () => moment().subtract(9, "months").format("YYYY-MM-DD"),
    };
    
    return dateMap[value]?.();
  },

  mergerAS400DateTime: (date: number, time: number)  => {
    const convertedDate = DateHelper.convertFromAS400Date(date.toString());
    const convertedTime = DateHelper.convertFromAS400Time(time.toString())
    return DateHelper.convertDateTimeFromDB(convertedDate, convertedTime);
  },

  todayDate: (format: string = "MM/DD/YYYY") => {
    return moment().format(format);
  },
};




export { DateHelper };
